import { useState } from "react";
import { db } from "../firebase";
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';

export default function Earlyemail() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    if (!email) return alert("Please enter an email");

    setLoading(true);

    try {
      await addDoc(collection(db, "early_access_emails"), {
        email,
        source: "reporting_engine_beta",
        createdAt: serverTimestamp(),
      });

      setSuccess(true);
      setEmail("");
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-slate-900 border border-slate-800 rounded-3xl p-6 text-white relative overflow-hidden group shadow-2xl">
      <div className="relative z-10">
        <div className="flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/20 px-2 py-1 rounded-md w-fit">
          <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse" />
          <span className="text-[9px] font-black uppercase tracking-widest text-emerald-400">
            Beta Integration
          </span>
        </div>

        <h4 className="mt-4 text-lg font-black leading-tight">
          Automated <br />
          <span className="text-indigo-400">Reporting Engine</span>
        </h4>

        <p className="text-xs text-slate-400 mt-2 font-medium">
          We are partnering with leading hardware providers to sync your inspection data directly into our cloud.
        </p>

        {/* LEAD MAGNET */}
        <div className="mt-5 space-y-2">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter email for early access"
            className="w-full bg-slate-800 border border-slate-700 rounded-xl px-4 py-2 text-xs focus:outline-none focus:border-indigo-500 transition-colors"
          />

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="w-full py-3 bg-white text-slate-900 text-[10px] font-black uppercase rounded-xl hover:bg-indigo-50 transition-all shadow-lg disabled:opacity-60"
          >
            {loading ? "Saving..." : success ? "You're on the list ✔" : "Notify Me on Launch"}
          </button>
        </div>
      </div>

      {/* Decorative Element */}
      <div className="absolute -right-4 -bottom-4 opacity-10 rotate-12 group-hover:rotate-0 transition-transform duration-700">
        <svg width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
        </svg>
      </div>
    </div>
  );
}
